export class Errors {
    constructor() {
        this.errors = [];
    }

    record(errors) {
        this.errors = [];
        if (Array.isArray(errors)) {
            this.errors = errors;
        }
    }

    get(field) {
        for (let error of this.errors) {
            if (error.source && error.source.parameter === field) {
                return codes[error.code] || error.title;
            }
        }
    }

    clear() {
        this.errors = [];
    }
}

const codes = {
    "project_name": "Название проекта должно состоять из букв и цифр, не длиннее 20 символов. ",
    "email": "Проверьте правильность ввода электронной почты. ",
    "password": "Пароль должен быть не меньше 6 символов и состоять из цифр, латиницы. ",
    "eqfield": "Пароли не совпадают. ",
}